module.exports = __webpack_public_path__ + "static/media/logo_chromastudio.cb892286.svg";